import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dbPost } from '../../apis/commonApi';
import { ModalContext, GlobalContext } from '../../components/contexts';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { nlPost } from '../../apis/notLoginApi';
import TextViewer from '../../components/inputComponents/TextViewer';

const SelectSub = () => {
  const [trmData, setTrmData] = useState(['', '', '']);
  useEffect(() => {
      document.title = '구독 선택';
    }, []);

  const { modalService } = useContext(ModalContext);
  const { store } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [categories, setCategories] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [agreements, setAgreements] = useState({
    terms_check: false,
    terms_check2: false,
  });

  const handleOpenModal = () => setIsModalOpen(true);

const handlePayment = async () => {
  try {
    const tossPayments = await loadTossPayments(
      process.env.REACT_APP_TOSS_CLIENT_KEY
    );

    const orderId = `order-${Date.now()}`;

    const paymentPayload = {
      amount: selectedProductData.prc,
      orderId,
      orderName: selectedProductData.subCtgryNm,
      customerName: '테스트 사용자',
      subCtgryId: selectedProductData.subCtgryId,
      paymentMethod: selectedPaymentMethod,
      successUrl: `${window.location.href}`,
      failUrl: `${window.location.href}`,
    };

    sessionStorage.setItem('paymentData', JSON.stringify(paymentPayload));
    sessionStorage.setItem(
      'selectedProductData',
      JSON.stringify(selectedProductData)
    );
    sessionStorage.setItem('paymentData', JSON.stringify(paymentPayload));
    sessionStorage.setItem('selectedProductData', JSON.stringify(selectedProductData));

    tossPayments.requestPayment('카드', paymentPayload);
  } catch (error) {
    modalService.errorAlert('결제 요청 중 오류가 발생했습니다.');
  }
};



  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const paymentKey = searchParams.get('paymentKey');
    const orderId = searchParams.get('orderId');
    const amount = searchParams.get('amount');
    const isSuccess = !!paymentKey && !!orderId && !!amount;

    if (isSuccess) {
      const insertPaymentHistory = async () => {
        const paymentData = JSON.parse(sessionStorage.getItem('paymentData'));
        const productData = JSON.parse(
          sessionStorage.getItem('selectedProductData')
        );

        const today = new Date();
        const useStrtYmd = `${today.getFullYear()}${String(
          today.getMonth() + 1
        ).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;


        try {
          const insertResponse = await dbPost('/pay/insertPaymentHistory.do', {
            paymentKey,
            orderId,
            amount,
            subCtgryId: productData.subCtgryId,
            paymentMethod: paymentData.paymentMethod,
            entSn: store.entSn,
            stlmCycl: productData.stlmCycl,
            useStrtYmd,
          });

          if (insertResponse <= 0) {
            throw new Error('결제 기록 등록 실패.');
          }

          const confirmResponse = await dbPost('/pay/confirm', {
            paymentKey,
            orderId,
            amount,
            stlmCycl: productData.stlmCycl,
          });

          if (confirmResponse.results.success) {
            modalService.successAlert('결제가 성공적으로 완료되었습니다!');
            navigate('/pay/SubList');
          } else {
            modalService.errorAlert('결제 확인 중 오류가 발생했습니다.');
          }
        } catch (error) {
          modalService.errorAlert('결제 처리 중 오류가 발생했습니다.');
          navigate('/pay/SubList');
        }
      };

      insertPaymentHistory();
    }
  }, []);


  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    setSelectedPaymentMethod(null);
    setAgreements({ terms_check: false, terms_check2: false });
  };

  const handleProductSelect = productId => {
    setSelectedProduct(productId);
  };

  const handlePaymentMethodSelect = methodId => {
    setSelectedPaymentMethod(methodId);
  };

  const handleAgreementChange = e => {
    const { id, checked } = e.target;
    setAgreements(prev => ({ ...prev, [id]: checked }));
  };

  useEffect(() => {
    fetchCategories();
    fetchPaymentMethods();
    fetchTerms();
  }, []);

  const fetchCategories = async () => {
    try {
      const url = '/pay/category/list.do';
      const response = await nlPost(url, {});
      setCategories(response);
    } catch (error) {
      setCategories([]);
    }
  };

  const fetchPaymentMethods = async () => {
    try {
      const url = '/pay/method/list.do';
      const response = await nlPost(url, { entSn: store?.entSn });
      setPaymentMethods(response);
    } catch (error) {
      setPaymentMethods([]);
    }
  };

  const fetchTerms = async () => {
    try {
      const url = '/member/mngTrms/list.do';
      const response = await nlPost(url, {});

      const newTrmData = [
        response?.uTrms?.trmsCn,
        response?.pTrms?.trmsCn,
        response?.bTrms?.trmsCn,
      ];

      setTrmData(newTrmData);
    } catch (error) {
      setTrmData(['', '', '']);
    }
  };


  const selectedProductData = categories.find(
    cat => cat.subCtgryId === selectedProduct
  );

  const calculateDates = () => {
    if (!selectedProductData) return {};
    const today = new Date();
    const nextPaymentDate = new Date(today);
    const usageEndDate = new Date(today);

    if (selectedProductData.stlmCycl === 'Y') {
      nextPaymentDate.setFullYear(today.getFullYear() + 1);
      usageEndDate.setFullYear(today.getFullYear() + 1);
    } else if (selectedProductData.stlmCycl === 'M') {
      nextPaymentDate.setMonth(today.getMonth() + 1);
      usageEndDate.setMonth(today.getMonth() + 1);
    }

    return {
      today: today.toISOString().split('T')[0],
      nextPaymentDate: nextPaymentDate.toISOString().split('T')[0],
      usagePeriod: `${today.toISOString().split('T')[0]} ~ ${
        usageEndDate.toISOString().split('T')[0]
      }`,
    };
  };



  const { today, nextPaymentDate, usagePeriod } = calculateDates();

  const isPaymentEnabled = Object.values(agreements).every(Boolean);
  return (
    <>
      <div>
        <div className="contents">
          <div className="page-title-wrap" data-type="responsive">
            <h2 className="h-tit">구매상품선택</h2>
          </div>
          <div className="chk-group-area">
            <h3 className="block-tit">원하시는 상품을 선택해 주세요</h3>
            <ul className="chk-group-wrap">
              {categories.map(({ subCtgryId, subCtgryNm, subCtgryCn, prc }) => (
                <li
                  key={subCtgryId}
                  className={selectedProduct === subCtgryId ? 'checked' : ''}
                  onClick={() => handleProductSelect(subCtgryId)}
                >
                  <div className="form-group chk-area chk-column">
                    <div className="form-check">
                      <input
                        type="radio"
                        name="product"
                        id={`chk_${subCtgryId}`}
                        checked={selectedProduct === subCtgryId}
                        onChange={() => handleProductSelect(subCtgryId)}
                      />
                      <label htmlFor={`chk_${subCtgryId}`}>
                        <strong className="tit">{subCtgryNm}</strong>
                        {prc && (
                          <strong className="price">{`${prc.toLocaleString()}원`}</strong>
                        )}
                        <span className="conts-desc">{subCtgryCn}</span>
                      </label>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="page-btn-wrap">
            {store?.logined && store?.userType !== 'U' ? (
              <button
                type="button"
                className="btn xlg primary open-modal"
                onClick={handleOpenModal}
                disabled={!selectedProduct}
              >
                이용권 선택
              </button>
            ) : (
              ''
            )}
          </div>
        </div>

        {isModalOpen && selectedProductData && (
          <section
            id="modal_sample_03"
            className={`modal fade ${isModalOpen ? 'shown in' : ''}`}
            style={{ display: isModalOpen ? 'block' : 'none' }}
            role="dialog"
            aria-labelledby="tit_modal_sample_03"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h2 id="tit_modal_sample_03" className="modal-title">
                    이용권 구매
                  </h2>
                </div>
                <div className="modal-conts">
                  <div className="tbl-wrap">
                    <h3 className="block-tit">결제정보</h3>
                    <table className="tbl data row">
                      <tbody>
                        <tr>
                          <th scope="row">결제 금액</th>
                          <td>
                            <p>{`${selectedProductData.prc.toLocaleString()}원 (VAT 포함)`}</p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">결제일</th>
                          <td>
                            <p>{`${today} (다음 결제일: ${nextPaymentDate})`}</p>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">이용기간</th>
                          <td>
                            <p>{usagePeriod}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="chk-group-area">
                    <h3 className="block-tit">결제수단 선택</h3>
                    <ul className="chk-group-wrap">
                      {paymentMethods.length === 0 ? (
                        <li>결제수단을 먼저 등록해 주세요</li>
                      ) : (
                        paymentMethods.map(({ stlmMthdId, idntfNm }) => (
                          <li
                            key={stlmMthdId}
                            className={
                              selectedPaymentMethod === stlmMthdId
                                ? 'checked'
                                : ''
                            }
                          >
                            <div
                              className="form-group chk-area chk-column"
                              onClick={() =>
                                handlePaymentMethodSelect(stlmMthdId)
                              }
                            >
                              <div className="form-check">
                                <input
                                  type="radio"
                                  name="save_id"
                                  id={stlmMthdId}
                                  checked={selectedPaymentMethod === stlmMthdId}
                                  onChange={() =>
                                    handlePaymentMethodSelect(stlmMthdId)
                                  }
                                />
                                <label htmlFor={stlmMthdId}>
                                  <strong className="tit">{idntfNm}</strong>
                                </label>
                              </div>
                            </div>
                          </li>
                        ))
                      )}
                    </ul>
                  </div>

                  <ul className="agree-box">
                    <li>
                      <span className="txt">
                        유료서비스약관 및 하단 유의사항에 동의합니다.
                      </span>
                      <div className="chk-area">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            id="terms_check"
                            checked={agreements.terms_check}
                            onChange={handleAgreementChange}
                          />
                          <label htmlFor="terms_check">동의함</label>
                        </div>
                      </div>
                    </li>
                    <li>
                      <span className="txt">정기 자동 결제에 동의합니다.</span>
                      <div className="chk-area">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            id="terms_check2"
                            checked={agreements.terms_check2}
                            onChange={handleAgreementChange}
                          />
                          <label htmlFor="terms_check2">동의함</label>
                        </div>
                      </div>
                    </li>
                  </ul>

                  <ul className="agree-box">
                    <li>
                      <span className="txt">
                        유료서비스약관 및 유의사항:
                        {trmData[2] ? (
                          <TextViewer content={trmData[2]} />
                        ) : (
                          <span>약관 없음</span>
                        )}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="modal-btn btn-wrap both">
                  <button
                    type="button"
                    className="btn tertiary md close-modal"
                    onClick={handleCloseModal}
                  >
                    취소
                  </button>
                  <button
                    type="button"
                    className="btn primary md close-modal"
                    onClick={handlePayment}
                    disabled={!isPaymentEnabled}
                  >
                    결제하기
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-back in"></div>
          </section>
        )}
      </div>
    </>
  );
};

export default SelectSub;
